import { app } from "../../../bootstrap/core";
import { pdfViewerComponent } from "./pdfViewer.component";

app.component("pdfViewer", pdfViewerComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/pdfViewer/pdfViewer.js